import React, { Fragment as _, memo, useMemo } from 'react';
import EditableText from 'components/lib/EditableText';
import Carousel from './Carousel';
import renderBlock from 'services/apiHelpers/renderBlock';
import { Row, Column } from '@chameleoncreator/creator-ui';
import ContinueBtn from 'components/lib/ContinueBtn/continueBtn_v2';
import Image from 'components/lib/Image';
import { interactionContext } from './interactionContext';
import { connect } from 'react-redux';
import Container from 'components/Layouts/ContainerLogical';
import { Block } from '@chameleoncreator/creator-app';
import getBlockById from 'services/apiHelpers/getBlockById';
import CarouselSlide from './CarouselSlide';
import IELayout from 'components/Layouts/IELayout';
import shouldUpdate from 'services/shouldUpdate';

const SingleColumnLayout = Row.bind({}) as any;
SingleColumnLayout.defaultProps = {
  ...(Row as any).defaultProps,
  flexDirection: 'column',
};

const TwoColumnLayout = Row.bind({}) as any;
TwoColumnLayout.defaultProps = {
  ...(Row as any).defaultProps,
  flexDirection: 'row',
};

const Components = {
  Row,
  Column,
  Text: EditableText,
  Carousel,
  Slide: CarouselSlide,
  Image,
  TwoColumnLayout: TwoColumnLayout,
  SingleColumnLayout: SingleColumnLayout,
  ContinueButton: ContinueBtn,
  ...IELayout(interactionContext),
};

const CarouselDisplay = memo((props: any) => {
  const interactionBlock = getBlockById(props.blockId);
  return (
    <Container
      id={interactionBlock.id}
      key={interactionBlock.id}
      {...interactionBlock.props}
      {...props}
    >
      <interactionContext.Provider
        value={{ ...interactionBlock, updateItemsSeen: null }}
      >
        {(interactionBlock.children as Block[]).map(child => {
          return renderBlock(child, Components);
        })}
      </interactionContext.Provider>
    </Container>
  );
}, shouldUpdate);

// const CarouselDisplay = props => {
//   const interactionBlock = getBlockById(props.blockId);

//   const container = (
//     <Container
//       id={interactionBlock.id}
//       key={interactionBlock.id}
//       {...interactionBlock.props}
//       {...props}
//     >
//       <interactionContext.Provider
//         value={{ ...interactionBlock, updateItemsSeen: null }}
//       >
//         {(interactionBlock.children as Block[]).map(child => {
//           return renderBlock(child, Components);
//         })}
//       </interactionContext.Provider>
//     </Container>
//   );

//   return window.dev()
//     ? container
//     : useMemo(() => {
//         // console.log('carousel renders');
//         return container;
//       }, [props.isOpen, interactionBlock.props.lockDown]);

//   return (
//     <Container
//       id={interactionBlock.id}
//       key={interactionBlock.id}
//       {...interactionBlock.props}
//       {...props}
//     >
//       <interactionContext.Provider
//         value={{ ...interactionBlock, updateItemsSeen: null }}
//       >
//         {(interactionBlock.children as Block[]).map(child => {
//           return renderBlock(child, Components);
//         })}
//       </interactionContext.Provider>
//     </Container>
//   );
// };

// export default connect((state: any, props: any) => {
//   const { data } = props;
//   const { background, carouselColor, carouselTextColor } = state.blocks[
//     data.id
//   ].props;

//   return {
//     background,
//     carouselColor,
//     carouselTextColor,
//     [Math.random()]: '',
//   };
// })(CarouselDisplay);

export default CarouselDisplay;
